import PhotoSwipe from 'photoswipe';
import PhotoSwipeUI_Default from 'photoswipe/dist/photoswipe-ui-default';

import { UI } from '../ui';

export let gallery = {

    bind : function() {

        const galleryGrids = document.querySelectorAll('.gallery__grid');

        if( galleryGrids !== null) {
            
            galleryGrids.forEach( function(galleryGrid) {
        
                let images = [];
                const galleryItems = galleryGrid.querySelectorAll('.gallery__item');

                galleryItems.forEach( function(galleryItem) {
                    
                    const src = galleryItem.querySelector('a').getAttribute('href');
                    const width = galleryItem.querySelector('a').dataset.width;
                    const height = galleryItem.querySelector('a').dataset.height;

                    const image = {
                        src,
                        w : width,
                        h : height,
                    }

                    images.push(image);

                    galleryItem.addEventListener('click', function(event) {

                        let index = this.dataset.index;
                        //console.log(typeof index);

                        const options = {
                            index : parseInt(index), //data attr need to be parsed!
                            bgOpacity: 0.9,
                            showHideOpacity: true,
                            closeOnScroll: false,
                            history: false,
                            fullscreenEl: false,
                            counterEl: false,
                            zoomEl: false,
                            shareEl: false,
                            timeToIdle: 10000,
                            timeToIdleOutside: 10000,    
                            showAnimationDuration: 0, 
                            hideAnimationDuration: 0,        
                            loop : false,
                        }							
                        
                        const pswp = document.querySelector('.pswp');
                        
                        const gallery = new PhotoSwipe(pswp, PhotoSwipeUI_Default, images, options);

                        // gallery.listen('afterChange', function() {
                        // 	gallery.zoomTo(1, {x:gallery.viewportSize.x/2,y:gallery.viewportSize.y/2}, 0, 0, false);
                        // });
            
                        if(UI.windowWidth > 960 && !UI.mobile) { 
                            gallery.init();
                            event.preventDefault();
                        }

                    });

                });


            });				

        }

    }

}